window.GIFTBOX_CUSTOM_UPDATE_CART = ()=>{
    document.documentElement.dispatchEvent(new CustomEvent('product:added',{
        bubbles: true,
        // same code for prestige theme
        detail: {
            quantity: 1,
        },
    }));
}